var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$parent.routeSection === 0
        ? [_c("MaterialSetup", { attrs: { formValue: _vm.formValue } })]
        : _vm.$parent.routeSection === 1
        ? [_c("StudyDesign", { attrs: { formValue: _vm.formValue } })]
        : _vm.$parent.routeSection === 2
        ? [_c("SitesAndDepots", { attrs: { formValue: _vm.formValue } })]
        : _vm.$parent.routeSection === 3
        ? [_c("SupplyChain", { attrs: { formValue: _vm.formValue } })]
        : _vm.$parent.routeSection === 4
        ? [_c("Packaging", { attrs: { formValue: _vm.formValue } })]
        : _vm.$parent.routeSection === 5
        ? [_c("Shippers", { attrs: { formValue: _vm.formValue } })]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }